import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import type {
  ProvinceCreateInput,
  ProvinceUpdateInput,
} from "@/modules/geo/domain/contracts";
import { isDevMode } from "@/shared/lib/config";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon, HelpCircleIcon } from "lucide-react";
import { useCreateProvince, useZonesQuery } from "../api/queries";
import { ProvinceFormTour, useProvinceFormTour } from "../tour";
import { ProvinceForm } from "../ui/ProvinceForm";

export function ProvinceCreatePage() {
  const nav = useNavigate({ from: "/app/geo/provinces/new" });
  const zonesQuery = useZonesQuery();
  const zones = zonesQuery.data ?? [];
  const createProvince = useCreateProvince();
  const { run, handleJoyrideCallback, startTour } = useProvinceFormTour();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ແຂວງ", to: "/app/geo/provinces" },
            { label: "ສ້າງໃໝ່" },
          ]}
        />
      </Header>
      <Main>
        <div className="flex flex-wrap items-center justify-between space-y-2">
          <div>
            <h2 className="flex items-center font-bold text-2xl tracking-tight">
              ສ້າງແຂວງ{" "}
              <Button
                variant="ghost"
                size="icon"
                onClick={startTour}
                className="ml-2 size-6"
                title="ເລີ່ມທົດລອງການນຳທາງ"
              >
                <HelpCircleIcon className="h-4 w-4" />
              </Button>
            </h2>
            <p className="text-muted-foreground">
              ເພີ່ມແຂວງ ຊື່ 3 ພາສາ, ໂຊນ (ບໍ່ບັງຄັບ), ສະຖານະ.
            </p>
          </div>
          <Button
            variant="outline"
            onClick={() => nav({ to: "/app/geo/provinces" } as any)}
          >
            <ArrowLeftIcon className="size-4" />
            ກັບຄືນ
          </Button>
        </div>
        <div className="mt-6 rounded-xl border bg-card p-6">
          <ProvinceForm
            zones={zones}
            onSubmit={async (
              values: ProvinceCreateInput | ProvinceUpdateInput,
            ) => {
              await createProvince.mutateAsync(values as ProvinceCreateInput);
              nav({ to: "/app/geo/provinces" } as any);
            }}
            onCancel={() => nav({ to: "/app/geo/provinces" } as any)}
            submitting={createProvince.isPending}
            onDevFill={isDevMode ? () => {} : undefined}
          />
        </div>
        <ProvinceFormTour run={run} onCallback={handleJoyrideCallback} />
      </Main>
    </>
  );
}
